"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relativeHumanReadableDate = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var relativeHumanReadableDate = date => {
  var now = (0, _moment.default)();
  var then = (0, _moment.default)(date);
  var diffInHours = now.diff(then, 'hour');
  if (diffInHours <= 24) {
    var hours = Math.floor(diffInHours);
    if (hours <= 1) {
      return 'recently';
    }
    return "".concat(hours, " hour").concat(hours > 1 ? 's' : '', " ago");
  }
  if (diffInHours <= 48) {
    return 'yesterday';
  }
  return "".concat(Math.floor(now.diff(then, 'day')), " days ago");
};
exports.relativeHumanReadableDate = relativeHumanReadableDate;